import { render, staticRenderFns } from "./VisitSummary.vue?vue&type=template&id=4932686e&scoped=true"
import script from "./VisitSummary.vue?vue&type=script&lang=js"
export * from "./VisitSummary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4932686e",
  null
  
)

export default component.exports